import React from 'react'
import { Query } from 'react-apollo';
import { countriesQuery } from 'scenes/SearchProjectsByCategory/components/CategoryFilter/queries';
import { PLACEHOLDER_MESSAGES_STEP1 } from '../../constants';
import { useIntl } from 'react-intl';
import { useFormikContext } from 'formik';
import CustomSelect from 'utils/components/CustomSelect';
import "./styles/CountrySelect.scss";
import queryAllCountries from './query';
import MultiSelect from 'utils/components/MultiSelect';

const CountrySelect = ({ name, updateField }) => {
  const intl = useIntl();
  const { values: { countryProject } } = useFormikContext();

  return (
    <Query query={queryAllCountries}>
      {({ loading, data, error, refetch })  => { 
        const countriesList = data?.countries?.edges.map(
          (country) => ({
            id: country.node.id,
            value: country.node.id,
            label: intl.locale === "es" ? country.node.alternateNames : country.node.name,
          })
        );

        if (error) {
          const {graphQLErrors, networkError} = error;
          if (graphQLErrors || networkError) {
            console.error("Error fetching countries GraphQL:", graphQLErrors);
            console.error("Error fetching countries Network:", networkError);
          }
        }

        const handleRefetch = (countrySearch) => {
          refetch({
            search: countrySearch,
          })
        }
        
        return (
          <MultiSelect
            className="city-select--step1"
            config={{
              name,
              initialValues: countryProject,
              selectValues: countriesList,
              placeholderMessage: intl.formatMessage(
                PLACEHOLDER_MESSAGES_STEP1["countryProject"]
              ),
              disabled: loading,
              disabledPlaceholder: intl.formatMessage({ 
                id: "ProjectStepForm.countries.loading",
                defaultMessage: "Cargando paises..."
              }),
            }}
            isOnlyOneOption
            updateField={updateField}
            onFilterChange={handleRefetch}
          />
        );      
      }}
    </Query>
  )
}

export default CountrySelect;
